import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, SECONDARY, PRIMARY, TERTIARY } from '@glu/buttons-react';
import useStyles from './Footer.styles';
import LocaleContext from '../../../locale';
import ValidatedButton from '../../../gluValidation/Button';

export const FooterComponent = ({ onCancel, onClear, onSave, sending }) => {
  const classes = useStyles();
  const locale = useContext(LocaleContext);

  return (
    <div className={classnames(classes.wrapper)}>
      <ValidatedButton
        name="save-ach-form"
        variant={PRIMARY}
        className="btn btn-primary"
        data-qa="save"
        type="button"
        onClick={onSave}
        disabled={sending}
      >
        {locale['common.save']}
      </ValidatedButton>
      <Button
        variant={SECONDARY}
        className="btn btn-secondary"
        data-qa="cancel"
        type="button"
        onClick={onCancel}
        disabled={sending}
      >
        {locale['common.cancel']}
      </Button>
      <Button
        variant={TERTIARY}
        className="btn btn-tertiary"
        data-qa="clear"
        type="button"
        onClick={onClear}
        disabled={sending}
      >
        {locale['common.clear']}
      </Button>
    </div>
  );
};

FooterComponent.propTypes = {
  sending: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
};

FooterComponent.defaultProps = {
  sending: false
};

export default FooterComponent;
